import AxiosInstance from "services/api";

export const CashReceiptService = {
  getPaginate: async (query) => {
    return await AxiosInstance.get("/private/cash-receipt", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/cash-receipt/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/cash-receipt", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/cash-receipt/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/cash-receipt/${id}`);
  },
};
